import { Button } from '@odekoteam/doppio';

import { useAppDispatch, useAppSelector } from '../../hooks/store';
import {
  nightEndSelector,
  selectedWarehouseIdSelector,
} from '../../state/selectors/delivery';
import { modalSelector } from '../../state/selectors/modal';
import { reopenRoute } from '../../state/slices/delivery';
import CancelButton from './CancelButton';

export function ReopenRouteModal(): JSX.Element {
  const dispatch = useAppDispatch();
  const nightEnd = useAppSelector(nightEndSelector);
  const { variables } = useAppSelector(modalSelector);
  const selectedWarehouseId = useAppSelector(selectedWarehouseIdSelector);

  const handleOnClickConfirm = (): void => {
    if (variables?.routeId && selectedWarehouseId && nightEnd?.viewing) {
      dispatch(
        reopenRoute({
          deliveryRouteId: variables.routeId,
          warehouseId: selectedWarehouseId,
          nightEnd: nightEnd.viewing,
        }),
      );
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
      <Button
        variant="secondary"
        id="unmark-route-completed-action-button"
        onPress={handleOnClickConfirm}
      >
        Yes
      </Button>
      <CancelButton />
    </div>
  );
}
